import { HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, Input, LOCALE_ID, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { isSameDay } from 'date-fns';
import * as _ from 'lodash';
import { Subject, filter } from 'rxjs';
import { Agency } from 'src/app/domain/agency';
import { EEventType } from 'src/app/domain/enums/eventType';
import { Event } from 'src/app/domain/event';
import { Intervention } from 'src/app/domain/intervention';
import { User } from 'src/app/domain/user';
import { CalendarModel } from 'src/app/model/calendar.model';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { SamplerCounterDto } from 'src/app/services/dto/sampler-counter';
import { EventService } from 'src/app/services/event.service';
import { InterventionService } from 'src/app/services/intervention.service';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { AgencyAndTechnicianSelectionDialog } from 'src/app/tools/ui/agency-and-technician-selection-box/agency-and-technician-selection-box';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { CustomEventDialog } from 'src/app/tools/ui/cutom-event-box/custom-event-box';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { BaseComponent } from '../base/base.component';
import { CalendarUser } from './day-view-scheduler.component';
import { NextStrategyDialog } from 'src/app/tools/ui/next-strategy-box/next-strategy-box';
import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';
import { DocumentService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';

export enum ESortType {
    ByCity = 'Par nom de ville',
    ByCP = 'Par Code Postal'
}

@Component({
    selector: 'app-my-calendar',
    templateUrl: './my-calendar.component.html',
    styleUrls: ['./my-calendar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyCalendarComponent extends BaseComponent implements OnInit, AfterViewInit {
    @Input() trackBy!: ($index: number, item: any) => number;
    @ViewChild('drawer') drawer!: MatDrawer;
    CalendarView = CalendarView;
    viewDate: Date = new Date();
    view: CalendarView = CalendarView.Day;
    events: CalendarEvent<{ id: number, event: any }>[] = [];

    externalEvents: CalendarEvent[] = []; // Unplanned

    refresh: Subject<any> = new Subject();
    activeDayIsOpen: boolean = false;
    @Input() locale!: string;
    // SamplerEventList: Event[] = [];
    Model: CalendarModel[] = [];

    AgencyList: Agency[] = [];
    SelectedAgency?: Agency;
    TechnicianList: User[] = [];
    SelectedTechnicianList: CalendarUser[] = [];

    // UnplannedList: Intervention[] = [];
    PlannedList: Event[] = [];
    PoseAgencyCounters?: SamplerCounterDto;
    DeposeAgencyCounters?: SamplerCounterDto;

    ReducedMode: boolean = false;

    SortTypeList: string[] = [
        ESortType.ByCP,
        ESortType.ByCity
    ]
    SelectedSortType: string = '';
    SegmentSize = 4;

    colors: any = {
        red: {
            primary: '#ad2121',
            secondary: '#FAE3E3',
        },
        blue: {
            primary: '#1e90ff',
            secondary: '#D1E8FF',
        },
        yellow: {
            primary: '#e3bc08',
            secondary: '#FDF1BA',
        },
    };
    @ViewChild('calendarHeader') header: ElementRef | undefined;
    get CalendarHeight() {
        // console.log(this.header ? `calc(100% - ${this.header.nativeElement.offsetHeight}px) !important` : 'auto !important')
        return this.header ? `calc(100% - ${this.header.nativeElement.offsetHeight}px) !important` : 'auto !important';
    }

    constructor(
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        protected override coreData: CoreData,
        private interventionService: InterventionService,
        private documentService: DocumentService,
        private eventService: EventService,
        private userService: UserService,
        public LoadingTask: LoadingTask,
        @Inject(LOCALE_ID) locale: string) {
        super(coreData);
        this.locale = locale;
    }

    ngAfterViewInit(): void {
        this.SelectedSortType = this.coreData.SortType ?? ''
        this.checkLocalDate()
        this.SegmentSize = this.coreData.SegmentSize

        console.log(this.coreData.RoleAndPermissions.Name)
        if (this.IsTechnicien) {
            this.getMyAgency();
            this.SelectedTechnicianList.push({
                id: 1,
                name: `${this.coreData.User?.FirstName} ${this.coreData.User?.LastName}`,
                Puid: `${this.coreData.User?.Puid}`,
                color: this.colors.blue,
                reducedMode: this.ReducedMode
                // fan: counters.Fan,
                // processMeasure: counters.ProcessMeasure,
                // pumpWithBattery: counters.PumpWithBattery,
                // pumpWithoutBattery: counters.PumpWithoutBattery
            })
            this.coreData.SamplerList = this.SelectedTechnicianList;
            this.getMyInterventionList(this.viewDate);
        } else {
            this.getAgencyList();
        }
    }

    ngOnInit(): void {

    }

    CanCleanCalendar() {
        if (!this.SelectedAgency || Temporal.PlainDate.compare(Temporal.PlainDate.from({ year: this.viewDate.getFullYear(), day: this.viewDate.getDate(), month: this.viewDate.getMonth() + 1 }), Temporal.Now.plainDateISO()) === -1) {
            return false;
        }
        return true
    }
    // onDrop(event: DndDropEvent) {
    //     // this.addMeasureToTheStage(event.data, event.event.offsetX, event.event.offsetY);
    //     console.log(event.data)
    // }
    onReduceModeClick() {

        this.ReducedMode = !this.ReducedMode;
        this.SelectedTechnicianList.forEach(x => x.reducedMode = this.ReducedMode)
    }

    onSegmentSizeClick() {
        if (this.SegmentSize === 4)
            this.SegmentSize = 2;
        else
            this.SegmentSize = 4

        this.coreData.SegmentSize = this.SegmentSize
    }

    openCustomEventBox(event?: Event) {
        const dialogRef = this.dialog.open(CustomEventDialog, {
            data: {
                event: event,
                users: _.intersectionBy(this.TechnicianList, this.SelectedTechnicianList, 'Puid')
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
                this.closeOpenMonthViewDay() // Refresh Calendar
            }
        });
    }

    getMyAgency() {
        this.userService.getMyAgency().subscribe(x => {
            this.SelectedAgency = x;
        })
    }

    getMyInterventionList(date?: Date) {
        let tDate;
        if (date) {
            tDate = Temporal.PlainDate.from({ year: date.getFullYear(), day: date.getDate(), month: date.getMonth() + 1 });
        }

        this.interventionService.getInterventionListByDate(tDate?.toJSON() ?? Temporal.Now.plainDateISO().toJSON()).subscribe(x => {
            this.PlannedList = x;
            this.buildCalendarForDispatch()
        });
    }

    getAgencyList() {
        this.userService.getUserAgencyList().subscribe(x => {
            this.AgencyList = x;
            this.checkAgencyInLocalData();
        });
    }

    checkAgencyInLocalData() {
        if (this.coreData.Agency) {
            this.SelectedAgency = this.coreData.Agency;
            this.getSamplerOfSelectedAgency();
        }
    }

    checkSamplerListInLocalData() {
        if (this.coreData.SamplerList) {
            this.SelectedTechnicianList = this.coreData.SamplerList;
            this.closeOpenMonthViewDay();
            if (this.IsDispatch) {
                this.drawer.open()
            }
        }
    }

    checkLocalDate() {
        if (this.coreData.CalendarDate) {
            this.viewDate = this.coreData.CalendarDate;
        }
    }

    getSamplerOfSelectedAgency() {
        if (!this.SelectedAgency)
            return;
        if (this.coreData.Agency?.AnalyticalUnitCode !== this.SelectedAgency.AnalyticalUnitCode) { // Clean only when changing agency
            this.coreData.Agency = this.SelectedAgency;
            this.TechnicianList = [];
            this.SelectedTechnicianList = [];
            this.coreData.SamplerList = [];
            this.events = [];
            this.buildCalendarForDispatch();
        }
        this.userService.getSamplerByAgencyList(this.SelectedAgency.AnalyticalUnitCode).subscribe(x => {
            this.TechnicianList = x;
            this.checkSamplerListInLocalData()
        });
    }

    // getSelectedTechnicien(event: MatSelectChange) {
    //     if (this.LoadingTask.IsLoading > 0) {
    //         event.source.writeValue(0);
    //         return;
    //     }

    //     let users: [] = event.value;
    //     this.SelectedTechnicianList = _.intersectionBy(this.coreData.SamplerList, users, 'Puid')
    //     let i = this.SelectedTechnicianList.length;

    //     users.forEach((x: User) => {

    //         if (!this.SelectedTechnicianList.find(y => y.Puid === x.Puid)) {

    //             this.SelectedTechnicianList.push({
    //                 id: i++,
    //                 name: `${x.FirstName} ${x.LastName}`,
    //                 Puid: x.Puid,
    //                 color: this.colors.blue,
    //                 reducedMode: this.ReducedMode
    //                 // fan: counters.Fan,
    //                 // processMeasure: counters.ProcessMeasure,
    //                 // pumpWithBattery: counters.PumpWithBattery,
    //                 // pumpWithoutBattery: counters.PumpWithoutBattery
    //             })
    //         }
    //     })

    //     for (let j = 1; j <= this.SelectedTechnicianList.length; j++) {
    //         this.SelectedTechnicianList[j - 1].id = j;
    //     }
    //     this.coreData.SamplerList = this.SelectedTechnicianList;
    //     this.buildCalendarForDispatch();
    // }

    getCountersForASampler(user: CalendarUser, isDepose: boolean) {

        // let counters: SamplerCounterDto = new SamplerCounterDto();
        // return await new Promise<SamplerCounterDto>((resolve, reject) => {
        return this.interventionService.getCounters(user.Puid, this.SelectedAgency!.AnalyticalUnitCode, this.viewDate.toISOString(), isDepose)
        // .subscribe(x => {
        //     counters = x;
        //     // resolve(counters);
        //     return counters
        // });
        // });
    }

    getGlobalCounters(isDepose: boolean) {
        this.interventionService.getGlobalCounters(this.SelectedAgency!.AnalyticalUnitCode, this.viewDate.toISOString(), isDepose).subscribe(x => {
            if (isDepose)
                this.DeposeAgencyCounters = x;
            else
                this.PoseAgencyCounters = x;
        });
    }

    getUnplannedList(date: string) {
        if (!this.SelectedAgency || !this.IsDispatch)
            return;

        this.interventionService.getUnplannedList(this.SelectedAgency.AnalyticalUnitCode, date).subscribe(x => {
            // this.UnplannedList = x
            this.prepareUnplannedCalendarEventList(x);
        });
    }

    prepareUnplannedCalendarEventList(list: Intervention[]) {
        this.externalEvents = [];
        _.forEach(list, x => {
            this.externalEvents.push({
                title: `${x.SamplingPoint.ZipCode} ${x.SamplingPoint.City} - ${x.SamplingPoint.Address}`,
                color: {
                    primary: 'pink',
                    secondary: 'antiquewhite',
                    secondaryText: 'royalblue'
                },
                start: new Date(),
                draggable: true,
                meta: {
                    isExt: true,
                    intervention: x,
                    duration: x.Duration > 0 ? x.Duration : 120,
                    clientName: x.SamplingPoint?.ClientName ?? 'Coincoin',
                    samplingPoint: x.SamplingPoint?.Name ?? 'NulPart'
                }
            })
        })
        this.reorderEventsByFilter();
    }

    reorderEventsByFilter() {
        if (this.SelectedSortType === ESortType.ByCP) {
            this.externalEvents = _.orderBy(this.externalEvents, x => x.meta.intervention.SamplingPoint.ZipCode, 'asc')
        } else if (this.SelectedSortType === ESortType.ByCity) {
            this.externalEvents = _.orderBy(this.externalEvents, x => x.meta.intervention.SamplingPoint.City, 'asc')
        }

        this.coreData.SortType = this.SelectedSortType
    }

    externalDrop(event: CalendarEvent) {
        if (this.externalEvents.indexOf(event) === -1) {
            this.events = this.events.filter((iEvent) => iEvent !== event);
            this.externalEvents.push(event);
        }
    }

    // Dropped From External Unplanned List
    eventDropped({
        event,
        newStart,
        newEnd,
        allDay,
    }: CalendarEventTimesChangedEvent): void {

        const externalIndex = this.externalEvents.indexOf(event);
        if (typeof allDay !== 'undefined') {
            event.allDay = allDay;
        }
        if (externalIndex > -1) {
            this.externalEvents.splice(externalIndex, 1);
            this.events.push(event);
        }
        event.start = newStart;
        if (newEnd) {
            event.end = newEnd;
        }
        if (this.view === 'month') {
            this.viewDate = newStart;
            this.activeDayIsOpen = true;
        }

        if (!event.meta.isExt || event.meta.user === undefined)
            return;

        // this.events = [...this.events];

        this.interventionService.saveEvent(event.meta.intervention.Code, event.meta.user.Puid, new Date(event.start.getTime() - (event.start.getTimezoneOffset() * 60000)).toJSON())
            .pipe(filter((e: any) => e instanceof HttpResponse))
            .subscribe(
                (httpevent: HttpResponse<any>) => {
                    if (httpevent.status === 200) {
                        event.meta.event = new Event({ Code: httpevent.body.code, Type: EEventType.Intervention });
                        event.meta.isExt = false;
                        NotificationManager.handleSuccess('Intervention ajoutée', this.snackBar);
                        this.events = [...this.events];
                    } else if (httpevent.status === 206) {
                        event.meta.event = new Event({ Code: httpevent.body.code, Type: EEventType.Intervention });
                        event.meta.isExt = false;
                        this.events = [...this.events];
                        NotificationManager.handleWarning(httpevent.body.message, this.snackBar);
                    } else if (httpevent.status === 400) {
                        NotificationManager.handleWarning(httpevent.body.message, this.snackBar);
                    }
                    else if (httpevent.status === 401) {
                        this.router.navigate(['/login']);
                    }
                    this.LoadingTask.deactivateLoading()
                });
        // .subscribe(x => {
        //     if (x) {
        //         event.meta.event = new Event({ Code: x, Type: EEventType.Intervention });
        //         event.meta.isExt = false;
        //         NotificationManager.handleSuccess('Intervention ajoutée', this.snackBar);
        //         this.events = [...this.events];
        //     }
        // })
    }

    getPlannedList(date: string) {
        if (!this.SelectedAgency)
            return;

        this.eventService.getPlannedList(this.SelectedAgency.AnalyticalUnitCode, date).subscribe(x => {
            this.PlannedList = x;
            this.buildCalendarForDispatch();
        });

        this.getGlobalCounters(true);
        this.getGlobalCounters(false);
    }

    search() {
        this.getUnplannedList(Temporal.Now.plainDateISO().toJSON());
        this.getPlannedList(Temporal.Now.plainDateISO().toJSON());
    }

    // buildCalendar() {
    //     this.events = [];
    //     for (let i = 0; i < this.SamplerEventList.length; i++) {
    //         // let measureList: string = '';
    //         // let hours: number = 0;
    //         // for (let j = 0; j < this.InterventionList[i].ProcessList.length; j++) {
    //         //     // measureList = measureList.concat(this.InterventionList[i].ProcessList[j].ProcessMesure.MeasureReferenceName + '&emsp;');
    //         //     hours += 0.5;
    //         // }
    //         // // measureList = measureList.concat('</br>');
    //         // for (let j = 0; j < this.InterventionList[i].ZoneList.length; j++) {
    //         //     for (let k = 0; k < this.InterventionList[i].ZoneList[j].ZoneMesureList.length; k++) {
    //         //         // measureList = measureList.concat(this.InterventionList[i].ZoneList[j].ZoneMesureList[k].MeasureReferenceName + '&emsp;');
    //         //         hours += 0.5;
    //         //     }
    //         // }
    //         let event: CalendarEvent = {
    //             title: `Intervention ${this.SamplerEventList[i].Intervention.Code}`,
    //             //`${measureList} `, // - ${this.InterventionList[i].ProcessList[j].ParentName}
    //             color: {
    //                 primary: 'pink',
    //                 secondary: 'antiquewhite',
    //                 secondaryText: 'white'
    //             },
    //             start: this.convertTemporalToDate(this.SamplerEventList[i].Intervention.PlannedOn),
    //             end: this.convertTemporalToDate(this.SamplerEventList[i].Intervention.PlannedOn.add({ minutes: this.SamplerEventList[i].Intervention.Duration })),
    //             meta: {
    //                 // user: this.TechnicianList[0],
    //                 intervention: this.SamplerEventList[i].Intervention,
    //                 event: this.SamplerEventList[i],
    //                 pml: this.SamplerEventList[i].Intervention.ProcessList.map(x => x.ProcessMesure),
    //                 zml: this.SamplerEventList[i].Intervention.ZoneList.map(x => x.ZoneMesureList).flat()
    //             }
    //         };

    //         this.events.push(event);
    //     }
    // }

    async buildCalendarForDispatch() {
        this.events = [];

        this.PlannedList.forEach(x => {

            if (this.SelectedTechnicianList.map(u => u.Puid).includes(x.Sampler.Puid)) {

                let event: CalendarEvent = {
                    title: `${x.Titre}`,
                    color: {
                        primary: 'pink',
                        secondary: x.Intervention?.Status === EInterventionStatus.PendingValidation ? 'black' : this.getColorPerType(x.Type),
                        secondaryText: 'royalblue'
                    },
                    start: this.convertTemporalToDate(x.From),
                    end: this.convertTemporalToDate(x.To),
                    draggable: this.IsDispatch ? true : false,
                    meta: {
                        user: this.SelectedTechnicianList.find(user => user.Puid === x.Sampler.Puid),
                        isExt: false,
                        event: x,
                        intervention: x.Intervention,
                        // duration: x.Duration > 0 ? x.Duration : 120,
                        clientName: x?.Intervention?.SamplingPoint?.ClientName ?? 'Coincoin',
                        samplingPoint: x?.Intervention?.SamplingPoint?.Name ?? 'NulPart'
                    }
                };
                this.events.push(event);
            }
        })
        // Refresh Counters
        this.interventionService.getCountersForSamplerList(this.SelectedTechnicianList.map(t => t.Puid), this.SelectedAgency!.AnalyticalUnitCode, this.viewDate.toISOString())
            .subscribe(counters => {
                // RESET COUNTERS
                this.SelectedTechnicianList.forEach(x => {
                    x.dpumpWithBattery = 0
                    x.dpumpWithoutBattery = 0
                    x.processMeasure = 0
                    x.pumpWithBattery = 0
                    x.pumpWithoutBattery = 0
                    x.fan = 0
                })
                for (let i = 0; i < counters.length; i++) {
                    let tech = this.SelectedTechnicianList.find(u => u.Puid === counters[i].samplerPuid)

                    if (tech) {
                        tech.fan = counters[i].fan;
                        tech.processMeasure = counters[i].processMeasure;
                        tech.pumpWithBattery = counters[i].pumpWithBattery;
                        tech.pumpWithoutBattery = counters[i].pumpWithoutBattery;

                        tech.dfan = counters[i].dFan;
                        tech.dpumpWithBattery = counters[i].dPumpWithBattery;
                        tech.dpumpWithoutBattery = counters[i].dPumpWithoutBattery;
                    }
                }
            });
        // for (let i = 0; i < this.SelectedTechnicianList.length; i++) {

        //     let x = this.SelectedTechnicianList[i];
        //     this.getCountersForASampler(x, false).subscribe(pcounters => {
        //         x.fan = pcounters.fan;
        //         x.processMeasure = pcounters.processMeasure;
        //         x.pumpWithBattery = pcounters.pumpWithBattery;
        //         x.pumpWithoutBattery = pcounters.pumpWithoutBattery;
        //     });

        //     this.getCountersForASampler(x, true).subscribe(dcounters => {
        //         x.dfan = dcounters.fan;
        //         x.dprocessMeasure = dcounters.processMeasure;
        //         x.dpumpWithBattery = dcounters.pumpWithBattery;
        //         x.dpumpWithoutBattery = dcounters.pumpWithoutBattery;
        //     });
        // }
    }

    getColorPerType(type: EEventType) {
        switch (type) {

            case EEventType.Pause:
                return 'pink'
            case EEventType.Formation:
                return 'orange'
            default:
                return 'antiquewhite'
        }
    }
    // private getTitle(event: Event) {
    //     switch (event.Type) {
    //         case EEventType.Formation:
    //             return 'Formation'
    //         case EEventType.Intervention:
    //             return ``
    //         case EEventType.Pause:
    //             return 'Pause'
    //         default:
    //             return 'Ooops'
    //     }
    // }

    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        // if (isSameMonth(date, this.viewDate)) {
        if (
            (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
            events.length === 0
        ) {
            this.activeDayIsOpen = false;
        } else {
            this.activeDayIsOpen = true;
        }
        this.viewDate = date;
        // }
    }

    // eventTimesChanged({
    //     event,
    //     newStart,
    //     newEnd,
    // }: CalendarEventTimesChangedEvent): void {
    //     this.events = this.events.map((iEvent) => {
    //         if (iEvent === event) {
    //             return {
    //                 ...event,
    //                 start: newStart,
    //                 end: newEnd,
    //             };
    //         }
    //         return iEvent;
    //     });
    //     this.handleEvent('Dropped or resized', event);
    // }
    eventTimesChanged({
        event,
        newStart,
        newEnd,
    }: CalendarEventTimesChangedEvent): void {
        this.interventionService.saveEvent(event.meta.intervention.Code, event.meta.user.Puid, new Date(event.start.getTime() - (event.start.getTimezoneOffset() * 60000)).toJSON())
            .pipe(filter((e: any) => e instanceof HttpResponse))
            .subscribe(
                (httpevent: HttpResponse<any>) => {
                    if (httpevent.status === 200) {
                        event.start = newStart;
                        event.end = newEnd;
                        this.events = [...this.events];
                        NotificationManager.handleSuccess('Intervention ajoutée', this.snackBar);
                    } else if (httpevent.status === 206) {
                        event.start = newStart;
                        event.end = newEnd;
                        this.events = [...this.events];
                        NotificationManager.handleWarning(httpevent.body.message, this.snackBar);
                    }
                    else if (httpevent.status === 400) {
                        NotificationManager.handleWarning(httpevent.body.message, this.snackBar);
                    } else if (httpevent.status === 401) {
                        this.router.navigate(['/login']);
                    }
                    this.LoadingTask.deactivateLoading()
                });
        // .subscribe(x => {
        //     if (x) {
        //         event.start = newStart;
        //         event.end = newEnd;
        //         this.events = [...this.events];
        //         NotificationManager.handleSuccess('Intervention ajoutée', this.snackBar);
        //     }
        // })
    }

    // Dropped From Sampler to sampler
    userChanged({ event, newUser }: any) {
        // event.color = newUser.color;
        event.meta.user = newUser;
        this.events = [...this.events];

        if (event.meta.intervention) {

            this.interventionService.saveEvent(event.meta.intervention.Code, event.meta.user.Puid, new Date(event.start.getTime() - (event.start.getTimezoneOffset() * 60000)).toJSON())
                .pipe(filter((e: any) => e instanceof HttpResponse))
                .subscribe(
                    (httpevent: HttpResponse<any>) => {
                        if (httpevent.status === 200) {
                            NotificationManager.handleSuccess('Intervention modifié', this.snackBar);
                        } else if (httpevent.status === 206) {
                            NotificationManager.handleWarning(httpevent.body.message, this.snackBar);
                        } else if (httpevent.status === 401) {
                            this.router.navigate(['/login']);
                        }
                        this.LoadingTask.deactivateLoading()
                    });
        }
        else { // Update custom events

            let Model: Event = new Event();
            let start: Date = new Date(event.start)
            let end: Date = new Date(event.end)
            Model.Code = event.meta?.event.Code;
            Model.Type = event.meta?.event.Type;
            Model.Titre = event.meta?.event.Titre;
            Model.Description = event.meta?.event.Description;
            Model.Sampler = event.meta.user;
            const offset = start.getTimezoneOffset();
            start.setHours(start.getHours() - offset / 60)
            end.setHours(end.getHours() - offset / 60)
            Model.From = Temporal.PlainDateTime.from(start.toISOString().substring(0, start.toISOString().length - 1));
            Model.To = Temporal.PlainDateTime.from(end.toISOString().substring(0, end.toISOString().length - 1));
            this.eventService.updateCustomEvent(Model).subscribe((x: string) => {
                if (x) {
                    NotificationManager.handleSuccess('Evènement ajouté', this.snackBar);
                }
            })
        }
        // .subscribe(x => {
        //     if (x) {
        //         NotificationManager.handleSuccess('Intervention modifié', this.snackBar);
        //     }
        // })
    }

    onDelete({ code }: any) {
        this.eventService.deleteEvent(code).subscribe(x => {
            if (x) {
                _.remove(this.events, x => x?.meta?.event.Code === code)
                this.events = [...this.events];
                this.getUnplannedList(this.viewDate.toISOString());
                NotificationManager.handleSuccess('Intervention supprimée !', this.snackBar);
            }
        })
    }

    handleEvent(action: string, event: CalendarEvent): void {
        if (action === 'Clicked' && event.meta.event.Type === EEventType.Intervention) {
            this.router.navigate([ENavigationRoute.Intervention, { interventionCode: event.meta.intervention.Code }]);
        }

        if (action === 'Clicked' && event.meta.event.Type !== EEventType.Intervention) { // Custom event
            this.openCustomEventBox(event.meta.event)
        }
    }

    closeOpenMonthViewDay() {
        this.coreData.CalendarDate = this.viewDate;
        this.activeDayIsOpen = false;
        this.externalEvents = [];

        if (this.IsTechnicien)
            this.getMyInterventionList(this.viewDate)
        else {
            this.getPlannedList(this.viewDate.toISOString())
        }
        this.getUnplannedList(this.viewDate.toISOString())
    }

    generateCalendar() {
        if (!this.SelectedAgency)
            return;
        this.interventionService.generateAutoPlan(this.SelectedAgency.AnalyticalUnitCode, this.viewDate.toISOString(), _.intersectionBy(this.TechnicianList, this.SelectedTechnicianList, 'Puid')).subscribe(x => {
            if (x) {
                this.closeOpenMonthViewDay();
                NotificationManager.handleSuccess('Génération terminée', this.snackBar);
            }
        })
    }

    cleanCalendar() {
        if (!this.SelectedAgency)
            return;
        const dialogRef = this.dialog.open(ConfirmBoxDialog, { width: '666px', data: { message: 'Etes-vous sur de vouloir supprimer l\'ensemble de la planification' } });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {

                this.eventService.deleteAllEvents(this.SelectedAgency!.AnalyticalUnitCode, this.viewDate.toISOString()).subscribe(x => {
                    if (x) {
                        this.closeOpenMonthViewDay();
                        NotificationManager.handleSuccess('Nettoyage terminée', this.snackBar);
                    }
                })
            }
        })
    }

    openAgencyAndTechnicianDialog() {
        const dialogRef = this.dialog.open(AgencyAndTechnicianSelectionDialog,
            {
                width: '666px', data: this.ReducedMode
            });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.SelectedAgency = result.selectedAgency;
                this.SelectedTechnicianList = result.selectedTechnicianList;
                this.buildCalendarForDispatch();
                this.closeOpenMonthViewDay();
            }
        })
    }

    openNextStrategy() {
        const dialogRef = this.dialog.open(NextStrategyDialog,
            {
                width: '666px', data: this.SelectedAgency?.AnalyticalUnitCode
            });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {

            }
        })
    }

    navigateToUserConfiguration() {
        this.router.navigate([
            ENavigationRoute.UserConfiguration,
            // { list: _.intersectionWith(this.SelectedTechnicianList, this.TechnicianList, (x, y) => x.Puid === y.Puid).map(x => x.Puid) }
        ]);
    }

    public navigateToDemetra(intervention: Intervention) {
        window.open(`${environment.demetraUrl}order;id=${intervention.Strategy.Id};interventionId=${intervention.Code}`, '_blank');
    }

    exportScreen() {

        this.documentService.generateCalendarExport(this.viewDate.toISOString(), _.intersectionBy(this.TechnicianList, this.SelectedTechnicianList, 'Puid')).subscribe(x => {
            if (x) {
                this.promptFile(x);
                NotificationManager.handleSuccess('Export généré !', this.snackBar);
            }
        });
    }

    public compareAgencyWith(m1: Agency, m2: Agency) {
        return m1 && m2 ? m1.AnalyticalUnitCode === m2.AnalyticalUnitCode : m1 === m2;
    }

    public compareUserWith(m1: CalendarUser, m2: CalendarUser) {
        return m1 && m2 ? m1.Puid === m2.Puid : m1 === m2;
    }

    protected trackItem = <T>(index: number, item: T) => {
        return this.trackBy?.(index, item) ?? index;
    };
}
